import React from 'react'

const VoiceOfBenificiars = () => {
    return (
        <div className='md:px-24 px-4 md:mt-5 mt-3'>
       <div className="flex md:gap-4 gap-1 items-center md:mb-6 mb-2">
        <h2 className="text-[#03897B] text-[10px] md:text-[32px] font-bold">
        VOICE OF BENEFICIARIES
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746386728/Expand_right_14_xsloli.png"
          alt="l"
          className="md:w-[57px] md:h-[59px] h-[13px] w-[13px]"
        />
      </div>


            <div className="relative w-full overflow-hidden rounded-lg bg-white md:mt-3 mt-1">
                <div className="relative w-full rounded-lg">

                    {/* Left Arrow */}
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745852236/Arrow_drop_left-1_m9jfq6.png"
                        alt="Left Arrow"
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 w-6 h-6 md:w-16 md:h-16 cursor-pointer"
                    />

                    {/* Right Arrow */}
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745852236/Arrow_drop_left_kes4u2.png"
                        alt="Right Arrow"
                        className="absolute right-2 top-1/2 transform -translate-y-1/2  w-6 h-6 md:w-16 md:h-16 cursor-pointer"
                    />

                    {/* Main Image */}
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746698042/image_1_g6dux6.png"
                        alt="Securing Agriculture in Namibia"
                        className="w-full md:h-[595px] object-cover rounded-lg transition-opacity duration-500"
                    />

                    {/* Play Icon */}
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                        alt="Play"
                        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[102px] md:h-[100px] z-10 cursor-pointer"
                    />

                    {/* Bottom Text Area */}
                    <div className="absolute bottom-2 md:bottom-1 md:left-8 w-full px-4">
                        {/* Main Heading */}
                        <h2 className="text-white text-[10px] md:text-[32px] font-normal tracking-wider md:mb-4 mb-4">
                            Mobi-Coach Technology driving sustainability
                        </h2>
                        <h2 className="text-white text-[10px] md:text-[32px] font-medium -mt-3" style={{ lineHeight: '1.20' }}>
                            URBAN FARMING COMMUNITY
                        </h2>

                        {/* Location */}
                        <div className="flex items-center gap-2 md:gap-0 mb-0">
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745792652/image_1674_c1enwc.png"
                                alt="Map Icon"
                                className="w-[12px] h-[12px] md:w-[32px] md:h-[32px]"
                            />
                            <p className="text-white text-[10px] md:text-[32px] font-light">
                                KZN, South Africa
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default VoiceOfBenificiars
